import { Button } from 'antd';
import styled from 'styled-components';

export const TariffActionContainerStyled = styled.div`
	display: none;
	flex-direction: column;
	align-items: flex-end;

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		display: flex;
	}
`;

export const PopoverTextStyled = styled.p`
	gap: 4px;
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 0;
	font-size: 14px;
`;

export const DropdownStyled = styled(Button)`
	width: unset;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		display: block;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		display: none;
	}
`;

export const MobileContainerStyled = styled.div`
	gap: 10px;
	display: flex;
	flex-direction: column;
	margin-top: 24px;

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		display: none;
	}
`;
